import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  greyCardCtn: {
    whiteSpace: "nowrap",
    background: "#eee",
    borderRadius: "4px",
    marginTop: "10px",
    padding: "10px",
    paddingTop: 0,
    "& a": {
      color: "#474747",
    },
    "& li": {
      fontSize: "0.8rem",
      padding: "10px 0 4px",
    },
    "& span": {
      fontSize: "0.8rem",
      fontWeight: 500,
      marginLeft: "-10px",
    },
  },
  cardContainer: {
    width: "100% !important",
    [theme.breakpoints.up("sm")]: {
      width: "384px !important",
    },
    "& #remo-sb-linkedin": {
      cursor: "pointer",
      paddingLeft: "12px",
      marginTop: "4px",
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:before": {
        content: "",
        position: "absolute",
        top: "8px",
        left: 0,
        background: `url("../../assets/linkedin.svg") no-repeat`,
        width: "25px",
        height: "25px",
        display: "block",
      },
      "& .linked-in-red-dot": {
        display: "none",
      },
      "& > div": {
        margin: 0,
        paddingLeft: "3px",
      },
    },
    "& .cc-av-wrap": {
      textAlign: "center",
      color: "#666",
      fontSize: "0.8rem",
      marginTop: "7px",
      lineHeight: "1.2rem",
      whiteSpace: "nowrap",
      marginLeft: "10px",
    },
    "& h5": {
      fontSize: "0.85rem",
      overflow: "hidden",
      "-webkit-line-clamp": 3,
      display: "-webkit-box",
      "-webkit-box-orient": "vertical",
      marginTop: "10px",
    },
    "& h6": {
      fontSize: "0.8rem",
      marginTop: "10px",
    },
    "& i": {
      color: "#999",
    },
    "& button": {
      "&:not(.avatar)": {
        fontSize: "0.85rem",

        "&:disabled img": {
          opacity: 0.4,
        },
      },
    },
  },
  cardContent: {
    padding: "10px",
  },
  cardActions: {
    padding: "0px 10px",
  },
  listItemText: {
    marginLeft: "10px",
  },
  closeButton: {
    position: "absolute",
    top: 0,
    right: 0,
    color: theme.palette.events.blueSecondary,
  },
  actionButton: {
    marginLeft: "10px",
  },
  moveText: {
    padding: 0,
    "& svg": {
      "& rect": {
        fill: "none",
      },
    },
  },
  userName: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  editButton: {
    marginLeft: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  editIcon: {
    width: "20px !important",
    height: "20px !important",
  },
  iconsContainer: {
    display: "flex",
    gap: "10px",
  },
  userIconContainer: {
    display: "flex",
    gap: "20px",
    marginRight: "15px",
  },
  getUser: {
    color: theme.palette.primary.main,
    marginLeft: "5px",
    fontWeight: "500",
  },
}));
